import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme, useMixin } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';
import { VerticalSeparator } from '@clds/separator';
import { ButtonMenu, DefaultButtonProps } from '@cld/button';
import { Icon } from '@cld/icon';
import { theme } from '../theme';

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${typography.lg.regular};
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.md};

  @media ${media.desktop({ minOnly: true })} {
    padding-right: 0;
  }

  @media ${media.tablet({ maxOnly: true })} {
    border-bottom: 1px solid ${theme.borderLine.color};
  }
`;

const Separator = styled(VerticalSeparator)`
  height: 42px;
  align-self: stretch;
  background: ${theme.components.searchSubheader.separatorColor};
  margin: 0 ${globalTheme.spacing.lg};
`;

const ClearButton: FC<React.PropsWithChildren<DefaultButtonProps>> = (buttonProps) => {
  const iconColor = useMixin(theme.components.searchSubheader.crossIconColor);
  return (
    <ButtonMenu data-test="clear-query" {...buttonProps}>
      <Icon color={iconColor} name="cross" />
    </ButtonMenu>
  );
};

export interface SearchSubheaderProps {
  actionButton: ReactNode;
}

export const SearchSubheaderCompoundParent: FC<React.PropsWithChildren<SearchSubheaderProps>> = ({ actionButton, children, ...restProps }) => (
  <Root data-test="search-sub-header" {...restProps}>
    {actionButton}
    <Separator verticalMargin="xs" />
    {children}
  </Root>
);

export const SearchSubheader = Object.assign(SearchSubheaderCompoundParent, {
  ClearButton,
});
